// src/components/LoadingPage.js
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { db, collection, getDocs } from "../firebase";
import LoadingSpinner from "./LoadingSpinner";

export default function LoadingPage() {
  const [error, setError] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    async function loadInitialData() {
      try {
        // Load data required for Dashboard (same as Dashboard.js)
        const [driversSnap, trucksSnap, tripsSnap, compSnap] = await Promise.all([
          getDocs(collection(db, "drivers")),
          getDocs(collection(db, "trucks")),
          getDocs(collection(db, "trips")),
          getDocs(collection(db, "complaints")),
        ]);
        console.log("Initial data loaded for dashboard");
        navigate("/"); // Redirect to dashboard
      } catch (error) {
        console.error("Error loading initial data:", error);
        setError("Failed to load application data. Please try again.");
      }
    }
    loadInitialData();
  }, [navigate]);

  return (
    <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", height: "100vh" }}>
      {error ? (
        <div style={{ textAlign: "center", padding: "20px", color: "#b91c1c" }}>
          {error}
          <p>
            <button
              onClick={() => navigate("/login")}
              className="btn-primary"
            >
              Return to Login
            </button>
          </p>
        </div>
      ) : (
        <>
          <LoadingSpinner />
          <p>Loading application data...</p>
        </>
      )}
    </div>
  );
}